import { NgModule } from "@angular/core";
import { RouterModule, Routes } from "@angular/router";
import { AuthGuard } from "src/app/core/guard/auth.guard";
import { BaseComponent } from "./base/base.component";

const routes: Routes = [
 
  {
    path: '',
    loadChildren: () => import('../pages/auth/auth.module').then(m => m.AuthModule)
    // loadChildren: () => import('../pages/home/home.module').then(m => m.HomeModule)
  },
  {
    
    path: '',
    component: BaseComponent,
    canActivate: [AuthGuard],
    children: [
      {
        path: 'login',
        loadChildren: () => import('../pages/auth/login/login.component').then(m => m.LoginComponent)
      },
      {
        path: '',
        loadChildren: () => import('../pages/auth/auth.module').then(m => m.AuthModule)
        // loadChildren: () => import('../pages/home/home.module').then(m => m.HomeModule)
      },
      {
        path: 'dashboard',
        loadChildren: () => import('../pages/dashboard/dashboard.module').then(m => m.DashboardModule)
      },


      {
        path: 'qrticket',
        loadChildren: () => import('./../../views/pages/qrticket/qrticket.module').then(m => m.QrticketModule)
      },

      {
        path:'freeride',
        loadChildren:()=>import('../pages/freeride/freeride.module').then(m=>m.FreerideModule)
      },
      {
        path:'passengerflow',
        loadChildren:()=>import('../pages/passengerflow/passengerflow.module').then(m=>m.PassengerflowModule)
      },
      {
        path:'phpdt',
        loadChildren:()=>import('../pages/phpdtdashboard/phpdtdashboard.module').then(m=>m.PhpdtdashboardModule)
      },
      {
        path:'parkingdashboard',
        loadChildren:()=>import('../pages/parkingdashboard/parkingdashboard.module').then(m=>m.ParkingdashboardModule)
      },
      {
        path:'parkingflow',
        loadChildren:()=>import('../pages/parkingflow/parkingflow.module').then(m=>m.ParkingflowModule)
      },
      {
        path:'parkingavailability',
        loadChildren: () => import('../pages/dashboard/dashboard.module').then(m => m.DashboardModule)

      }

    ]
  }
]

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class LayoutRoutingModule { }
